import { Grid, Box } from "@mui/material";
import RadarChart from "./RadarChart";
import BarChart from "./BarChart";
import ResizableDrawer from "../../../Components/ResizableDrawer";
import CollapsableCard from "../../../Components/CollapsableCard";

function VisContainer() {
  return (
    <>
      <ResizableDrawer direction="right" width={window.innerWidth / 5}>
        <Box p={1}>
          <Grid container spacing={1}>
            <Grid item xs={12} md={12} lg={12} xl={12}>
              <CollapsableCard
                collapse={true}
                variant="outlined"
                title="Comparisons"
                subheader="KPIs on areas of interests"
              >
                <RadarChart />
              </CollapsableCard>
            </Grid>
            <Grid item xs={12} md={12} lg={12} xl={12}>
              <CollapsableCard
                collapse={true}
                variant="outlined"
                title="Bar Chart"
                subheader="Metrics and KPIs"
              >
                <BarChart />
              </CollapsableCard>
            </Grid>
            <Grid item xs={12} md={12} lg={12} xl={12}>
              <CollapsableCard
                collapse={true}
                variant="outlined"
                title="Insights"
                subheader="Description of the data"
              >
                
                <h1>Insights</h1>

<h2>Walkability</h2>

<p><strong>The masterplan creates an interconnected lattice of streets and pathways, forming fine-grained pedestrian-friendly corridors to support pedestrian activity and reinforce walkability as a core design principle. Localized improvements in walkability are concentrated around key corridors and intersections, particularly near Barabashova Market</strong>. These changes reflect efforts to enhance pedestrian accessibility and integrate the site with its surroundings and transportation options.</p>

<p>Walkability in the Science Neighborhood improves across all phases, with average scores rising from 0.59 in the baseline case to 0.67 in Phase 2, an increase of 13%, bringing it in line with the City Center. In contrast, Saltivka remains more fragmented and car-dependent, with an average score of 0.46, reflecting a less pedestrian-friendly environment. Note that this score would be even lower if walkways in park areas were not included.</p>

<p>The street network structure of the Masterplan improves access to the street network for surrounding areas (within a 10 minute walk of the Masterplan) and boosts access to metro entrances and bus routes, with the average walkability score for these areas rising from 0.45 to 0.50 (11%).</p>

<blockquote>
<p><em>Walkability index precedent: Cerin, E., et al. (2022) 'Urban design, transport, and health 2: Determining thresholds for spatial urban design and transport features that support walking to create healthy and sustainable cities: Findings from the IPEN Adult study', The Lancet Global Health, 10(6), pp. e895–e906. Available at: <a href="https://doi.org/10.1016/S2214-109X(22)00068-7">https://doi.org/10.1016/S2214-109X(22)00068-7</a></em></p>
<p><em>Estimated population data: Schiavina M., Freire S., Carioli A., MacManus K. (2023): GHS-POP R2023A - GHS population grid multitemporal (1975-2030). European Commission, Joint Research Centre (JRC)</em></p>
<p><em>Map data copyrighted OpenStreetMap contributors and available from <a href="https://www.openstreetmap.org">https://www.openstreetmap.org</a>. (Accessed: December 2024).</em></p>
</blockquote>

<h2>Granular Urban Fabric</h2>

<p>The Science Neighborhood is located near the Barabashova Market which has a remarkably porous spatial structure consisting of a multitude of interconnected walkways, extremely high numbers of active store frontages, and a rich mix of retail locations. <strong>The masterplan intervention complements the market’s vibrant character</strong> by adopting a lattice-like arrangement of streets and pedestrian walkways which transition the granular spatial structure of the market (0.84 average granularity score) into the less granular spatial structure of existing residential areas (0.55 average granularity score). The adoption of a porous street network enables the Science Neighbourhood to tap-into the functional vibrancy of the market area, thereby enhancing the potential of the newly developed areas to nurture social and functional diversity supportive of lively pedestrian friendly streets.</p>

<p>The City Center and Saltivka, serving as comparative benchmarks, underscore the distinctiveness of the market area. The City Center’s mean granularity score of 0.62 is lower than the market area but higher than Saltivka, which has a lower average of 0.48 due to its more monolithic spatial structure.</p>

<blockquote>
<p><em>Map data copyrighted OpenStreetMap contributors and available from <a href="https://www.openstreetmap.org">https://www.openstreetmap.org</a>. (Accessed: December 2024).</em></p>
</blockquote>

<h2>Access to Nature</h2>

<p><strong>The Science Neighbourhood improves access to green and blue spaces across all phases</strong>. Reflecting efforts to enhance access to ecological and recreational opportunities in the area, average scores for access to green and blue spaces increase from 0.25 in the baseline scenario to 0.69 in Phase 2, an increase of 176%. A core feature of the site is the green spine running from north to south, which integrates the design with surrounding green areas and provides nearby access to nature from many different locations within the Science Neighbourhood. The zone surrounding the masterplan (10-min walk from the science neighbourhood) also benefits, with scores rising 19.6%, from 0.46 in the baseline scenario to 0.55 in Phase 2, indicating the positive spillover effects of the masterplan interventions.</p>

<p>The City Center and Saltivka display relatively high values despite their difference urban designs, with mean green space percentages hovering around 0.62 and 0.59, respectively. The City Center’s high values can be attributed to its key location, surrounded by rivers, a feature that the Science Neighborhood also seeks to integrate into its design. By contrast, the high green values observed in Saltivka reflect its peripheral location near undeveloped open spaces.</p>

<p>The strategic incorporation of green space not only improves access to nature but also helps to mitigate urban heat islands and promote biodiversity while strengthening the Science Neighborhood’s capacity to provide a restorative and enriching environment for its inhabitants.</p>

<blockquote>
<p><em>Map data copyrighted OpenStreetMap contributors and available from <a href="https://www.openstreetmap.org">https://www.openstreetmap.org</a>. (Accessed: December 2024).</em></p>
</blockquote>
               </CollapsableCard>
            </Grid>
          </Grid>
        </Box>
      </ResizableDrawer>
    </>
  );
}

export default VisContainer;
